import { NgModule } from '@angular/core';
import {
	AuthModule,
	LogLevel,
	OpenIdConfiguration,
	StsConfigHttpLoader,
	StsConfigLoader
} from 'angular-auth-oidc-client';
import { of } from 'rxjs';
import { environment } from '../../environments/environment';

export const httpLoaderFactory = (): StsConfigHttpLoader => {
	const config$ = of({
		authority:
			'https://login.microsoftonline.com/lyrawellbeing.health/v2.0',
		authWellknownEndpointUrl: environment.authLogin,
		redirectUrl: window.location.origin + '/home',
		clientId: '5ae8a811-aec9-4dc9-b1b8-337724d3e376',
		scope: 'openid profile offline_access email https://icas.health/api/Echo.Api', // 'openid profile offline_access ' + your scopes
		responseType: 'code',
		triggerAuthorizationResultEvent: true,
		eagerLoadAuthWellKnownEndpoints: true,
		startCheckSession: false,
		disableRefreshIdTokenAuthTimeValidation: true,
		ignoreNonceAfterRefresh: true,
		useRefreshToken: true,
		renewTimeBeforeTokenExpiresInSeconds: 60 * 5,
		silentRenew: true,
		tokenRefreshInSeconds: 60,
		autoUserInfo: false,
		secureRoutes: ['https://api.lyrawellbeing.health/'],
		postLoginRoute: '/home',
		forbiddenRoute: '/forbidden',
		unauthorizedRoute: '/unauthorized',
		postLogoutRedirectUri: window.location.origin,
		logLevel: LogLevel.Debug
	} as OpenIdConfiguration);

	return new StsConfigHttpLoader(config$);
};

@NgModule({
	imports: [
		AuthModule.forRoot({
			loader: {
				provide: StsConfigLoader,
				useFactory: httpLoaderFactory,
				deps: [] // Removed FeatureFlagsService from deps
			}
		})
	]
})
export class AuthConfigModule {}
